import { REDUCER_NAME as APP_REDUCER_NAME } from 'constants';
import { REDUCER_NAME } from './constants';

export const getRootState = (state) => state[APP_REDUCER_NAME][REDUCER_NAME];

const getState = (state) => getRootState(state)[REDUCER_NAME];

export const getResults = (state) => getState(state).data;

export const getIsFetching = (state) => getState(state).isFetching;

export const getSalesOrders = (state) => getState(state).salesOrders;

export const getIsFetchingSalesOrders = (state) => getState(state).isFetchingSalesOrders;

export const getIsBatchingOrders = (state) => getState(state).isBatchingOrders;

export const getIsBatchingScreenOpened = (state) => getState(state).isBatchingScreenOpened;
export const getIsGeneratingReport = (state) => getState(state).isGeneratingReport;

export const getBatchedSalesOrders = (state) => getState(state).batchedSalesOrders;

export const getIsBatchedSuccessfully = (state) => getState(state).isBatchedSuccessfully;
